import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { schemasAdapter } from './schemasReducer';
import { SchemasStateModel } from './schemasStateModel';

const selectSchemasState = (state: RootState): SchemasStateModel => state.schemas;

export const selectIsLoadingSchemas = createSelector(
  selectSchemasState,
  state => state.loading,
);

export const selectErrorsForSchemas = createSelector(
  selectSchemasState,
  state => state.errors,
);

export const {
  selectAll: selectAllSchemas,
  selectById: selectSchemaByName,
} = schemasAdapter.getSelectors(selectSchemasState);

export const selectSelectedSchemaName = createSelector(
  selectSchemasState,
  state => state.selectedSchemaName,
);

export const selectSelectedSchema = createSelector(
  [selectAllSchemas, selectSelectedSchemaName],
  (schemas, selectedSchemaName) => (
    schemas.find(schema => schema.name === selectedSchemaName)
  )
);
